import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading } from "@/components/ui/section-heading";

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  title?: string;
  eyebrow?: string;
  items: FaqItem[];
  className?: string;
}

export function FaqSection({ 
  title = "Frequently Asked Questions", 
  eyebrow = "FAQ", 
  items, 
  className = "" 
}: FaqSectionProps) {
  return (
    <section className={`py-24 bg-shell border-t border-sand-deep ${className}`}>
      <div className="container mx-auto px-6 max-w-3xl">
        <SectionHeading 
          eyebrow={eyebrow}
          title={title}
          align="center"
          className="mb-14"
        />
        <Accordion type="single" collapsible className="w-full">
          {items.map((faq, i) => (
            <AccordionItem 
              key={faq.question} 
              value={`faq-${i}`}
              className="border-b border-sand-deep last:border-0"
            >
              <AccordionTrigger className="text-left font-serif font-bold text-ink text-xl md:text-2xl hover:no-underline py-6 group">
                <span className="group-hover:text-ink-soft transition-colors">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-ink-soft text-[15px] md:text-[16px] leading-relaxed pb-8 pr-8">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
